import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MunilyAreaPictureUploaderSize, MUNILY_AREA_PICTURE_UPLOADER_DEFAULTS } from './area-picture-uploader.types';

@Component({
  selector: 'common-area-picture-uploader',
  templateUrl: './area-picture-uploader.component.html',
  styleUrls: ['./area-picture-uploader.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AreaPictureUploaderComponent implements OnChanges {
  @Input() imageUrl: string | undefined = undefined;
  @Input() size: MunilyAreaPictureUploaderSize = MUNILY_AREA_PICTURE_UPLOADER_DEFAULTS.size;
  @Input() alt: string = MUNILY_AREA_PICTURE_UPLOADER_DEFAULTS.alt;
  @Input() disabled: boolean = MUNILY_AREA_PICTURE_UPLOADER_DEFAULTS.disabled;
  /** Marca visual tipo "selected" + check_circle (ej. foto principal). */
  @Input() selected: boolean = false;
  @Input() showReplaceOption: boolean = true;
  @Input() showSetPrimaryOption: boolean = true;
  @Input() showDeleteOption: boolean = true;

  @Output() upload = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();
  @Output() menuAction = new EventEmitter<'replace' | 'setPrimary' | 'delete'>();

  public containerClasses: string[] = [];

  constructor(private readonly sanitizer: DomSanitizer) {
    this.syncContainerClasses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['size'] || changes['imageUrl'] || changes['disabled'] || changes['selected']) {
      this.syncContainerClasses();
    }
  }

  // Angular sanitiza URLs en [src]; blob:/data: locales hay que marcarlas como seguras.
  get safeImageSrc(): string | SafeUrl {
    const url = this.imageUrl;
    if (!url) {
      return '';
    }
    if (url.startsWith('blob:') || url.startsWith('data:')) {
      return this.sanitizer.bypassSecurityTrustUrl(url);
    }
    return url;
  }

  get isFilled(): boolean {
    return !!this.imageUrl;
  }

  onContainerClick(): void {
    if (!this.disabled && !this.isFilled) {
      this.upload.emit();
    }
  }

  onRemoveClick(): void {
    if (!this.disabled) {
      this.remove.emit();
    }
  }

  onMenuAction(action: 'replace' | 'setPrimary' | 'delete'): void {
    if (!this.disabled) {
      this.menuAction.emit(action);
    }
  }

  private syncContainerClasses(): void {
    const next: string[] = [];
    if (this.size === 'small') next.push('munily-area-picture-uploader--small');
    if (this.size === 'large') next.push('munily-area-picture-uploader--large');
    if (this.isFilled) next.push('munily-area-picture-uploader--filled');
    if (!this.isFilled) next.push('munily-area-picture-uploader--empty');
    if (this.disabled) next.push('munily-area-picture-uploader--disabled');
    if (this.selected) next.push('munily-area-picture-uploader--selected');
    this.containerClasses = next;
  }
}
